<template>
    <div class="">
        <div class="row">
            <div class="col-sm-3"><b-avatar class="" variant="light" rounded button size="150px" ></b-avatar></div>
            <div class="col-sm-9">
                <div class="row">
                    <div class="col-sm-6">Employee Leave and Attendances</div>
                    <div class="col-sm-6">{{employeename}}</div>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-sm-4 border px-1 py-1 ">
                <div class="card p-3">
                    <div>
                        Leave and Attendance List for <br />
                        <span class="font-weight-bold">{{employeename}}</span>
                    </div>
                    <div class="mt-2">
                        From: {{start_date}}<br />
                        To: {{end_date}}
                    </div>
                </div>
                <div class="card mt-3">
                        <div class="card-header">
                            Result
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">Total working days: {{total_working_day}}</li>
                            <li class="list-group-item">Weekends: {{total_weekends}}</li>
                            <li class="list-group-item">Holiday(s): {{total_holidays}}</li>
                            <li class="list-group-item">Leave(s): {{total_leaves}}</li>
                        </ul>
                    </div>
            </div>
            <div class="col-sm-8">
                <div class="" v-if="this_month_holidays">       
                    <v-calendar is-expanded  :masks="masks" :attributes="attributes" :first-day-of-week="first_day_of_week" ref="trzcalendar"
                        class='v-calendar ' is-dark  @update:to-page="monthDetails" >
                        <template slot="day-content" class='vc-w-full vc-relative' slot-scope='{day, dayEvents, attributes, attributesMap , popover}'>
                            <div v-bind:class='{"holiday": weekly_holidays.includes(day.weekday)}'>
                                <div v-if="this_month_holidays[day.id]" :style="{'background-color':this_month_holidays[day.id].color}" :title="this_month_holidays[day.id].title">                                
                                    <div class="flex flex-column h-100 overflow-hidden">
                                        <div class="day-label text-sm text-gray-900" >{{day.day}}</div>
                                    </div>
                                </div>
                                <div v-else>                                
                                    <div class="flex flex-column h-100 overflow-hidden">
                                        <div class="day-label text-sm text-gray-900">{{day.day}}</div>
                                    </div>
                                </div>
                            </div>
                            
                        </template>
                    </v-calendar>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    
    import moment from 'moment'
    export default{
        
        mounted() {
            this.$refs.trzcalendar;
        }, 
        components: {
            
        },     
        data(){
            
            return {
                fdata: [],
                cu:window.location.href,
                ce:false, 
                company_id:0,
                employeename:'',           
                logosrc:null,
                
                start_date: null,
                end_date: null,
                
                this_month_holidays : [],

                weekly_holidays : [6],
                first_day_of_week : 7,

                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,
                                
                masks : 
                    {
                        title: 'MMMM YYYY',
                        weekdays: 'WW',
                        navMonths: 'MMM',
                        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                        dayPopover: 'WWW, MMM D, YYYY',
                        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    },

                attributes: [
                        {
                            key: 'today',
                            dot: 'pink',
                            dates: new Date(),
                        }
                    ],
               
                
            }
        },
        methods:{

            monthDetails: function(x)
            {              
                let currentObj = this;
                let year = x['year'];
                let month = x['month'];
                let st_date = new Date(year , month - 1 , 1);
                let en_date = new Date(year , month , 0);

                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');
                
                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/holidays/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){
                    
                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10) + 1;});
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;
                    
                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                        
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            },   
            getCompanyData:function() 
            {   
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        this.fdata = response.data;
                        this.company_id =  response.data.id;
                        this.logosrc = this.$api_url+'/images/company/' + response.data.logo;                        
                        this.companyname =  response.data.name;
                        this.companyaddress =  response.data.address;
                    }        
                    
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

        },
        created: function(){
            this.getCompanyData();
            
        },
        computed: 
        {
            
        }
    }
</script>